<template>
  <transition :name="transitionName">
    <div class="notification alert" :class="[typeClass, hasIcon]" v-show="isShow">
      <span v-if="closable" class="close" @click="handleClose">×</span>
      <div class="wrap-icon" v-if="iconClass"><i :class="['fa', `fa-${iconClass}`, faSpin]"></i></div>
      <div class="title is-5" v-if="title">{{ title }}</div>
      <div class="notification-content" v-html="content"></div>
    </div>
  </transition>
</template>
<script>
export default {
	name:'Notify',
  props: {
    type: {
      type: String,
      default: 'default',
    },
    title: {
      type: String,
    },
    content: {
      type: String,
      default: '',
    },
    closable: {
      type: Boolean,
      default: true,
    },
    onClose: {
      type: Function,
      default() {},
    },
    duration: {
      type: Number,
      default: 3000,
    },
    placement: {
      type: String,
      default: 'top-right',
    },
    icon: {
      type: String,
    },
    animated: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
    },
  },

  data() {
    return {
      isShow: false,
      placementTransition: {
        'top-right': 'fadeRight',
        'top-center': 'fadeDown',
        'top-left': 'fadeLeft',
        'bottom-right': 'fadeRight',
        'bottom-center': 'fadeUp',
        'bottom-left': 'fadeLeft',
      },
    };
  },

  computed: {
    typeClass() {
      return this.type ? `is-${this.type}` : null;
    },
    hasIcon() {
      return this.iconClass ? 'has-icon' : null;
    },
    faSpin() {
      return this.animated ? 'fa-spin' : null;
    },
    iconClass() {
      if (this.icon) return this.icon;

      if (this.type === 'info') {
        return 'info-circle';
      } else if (this.type === 'success') {
        return 'check-circle';
      } else if (this.type === 'warning') {
        return 'exclamation-triangle';
      } else if (this.type === 'danger') {
        return 'times-circle';
      } else if (this.type === 'loading') {
        this.type = 'info';
        this.animated = true;
        return 'spinner';
      }
      return this.icon;
    },
    transitionName() {
      if (this.transition) return this.transition;
      return this.placementTransition[this.placement];
    },
  },

  methods: {
    handleClose() {
      this.isShow = false;
      setTimeout(() => {
        this.$destroy();
        this.$el.remove();
      },100);
    },
    close() {
     clearTimeout(this.timer);
      this.isShow = false;
      this.$destroy();
      this.$el.remove();
    },
  },

  beforeMount() {
    let parent;
    parent = document.querySelector(`.notifications.${this.placement}`);

    if (!parent) {
      parent = document.createElement('div');
      parent.classList.add('notifications', this.placement);
      document.body.appendChild(parent);
    }
    parent.innerHTML=''
    parent.appendChild(this.$el);
  },

  mounted() {
    this.isShow = true;
    this.timer = setTimeout(() => this.close(), this.duration);
  },
};
</script>
<style>
	
.notifications { 
  position: fixed;
  top: 20px;
  right: 0;
  z-index: 1257;
  pointer-events: none;
 }
.notifications.top-center {
  right: 0;
  left: 0;
  margin: 0 auto; 
  z-index: 999999;
  }
.notifications.top-left {
  right: auto;
  left: 0; }
.notifications.bottom-left {
  top: auto;
  bottom: 20px;
  right: auto;
  left: 0; }
.notifications.bottom-center {
  top: auto;
  bottom: 20px;
  right: 0;
  left: 0;
  margin: 0 auto; 
}
.notifications.bottom-right {
  top: auto;
  bottom: 20px; }
@media screen and (min-width: 769px) {
  .notifications {
    max-width: 320px; 
  } 
}
.notifications .notification {
  padding: 16px 20px;
  border-radius: 3px;
  margin: 10px; }
.notifications .notification.has-icon {
  padding-left: 45px; }
.notifications .notification.is-default {

  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  background-color: #fff; }
.notifications .notification .close {
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  cursor: pointer;
  filter: alpha(opacity=20);
  opacity: .2;
  font-family: Arial,sans-serif;
  font-family: Arial,sans-serif;
  float: right;
  margin: -13px -14px 0 20px; 
  &:hover{
    opacity: .4;
    filter: alpha(opacity=0);
  }
}
.alert {
  position: relative;
  min-width: 240px;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  pointer-events: all; }
.alert.has-icon {
  padding-left: 45px; }
.alert .title {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 16px; }
.alert .notification-content {
  margin-top: 0px; }


.notification.is-success {
  background-color: #6cc788;
  color: #fff;
}

.notification.is-danger{
  background-color: #f56954;
  color: #fff;
}

.notification.is-warning{
  background-color: #f39c12;
  color: #fff;
}

</style>


// WEBPACK FOOTER //
// src/components/notify/Notify.vue